export const canPrescribe = (allSpecialities, mySpecialities) => {
  let allow_prescribe = false;
  allSpecialities.forEach(speciality => {
    if (mySpecialities.includes(speciality.id) && speciality.allow_prescribe) {
      allow_prescribe = true;
    }
  });
  return allow_prescribe;
};
